import React, { useState } from 'react';
import socket from '../socket';
import { wordCategories } from '../data/words';

const RoomOptions = ({ playerId, gameSyncData, createdRoomData, onClose }) => {
  const roomId = createdRoomData.roomId;
  const [category, setCategory] = useState('Animals');
  const [rounds, setRounds] = useState(3);
  const [timer, setTimer] = useState(60);
  const [error, setError] = useState('');
  const [selectedActor, setSelectedActor] = useState(playerId);
  const categories = ['Animals', 'Movies', 'Food', 'Place', 'Celebrities', 'Sports', 'Professions', 'Random'];

  const validateForm = () => {
    if (!category.trim()) return 'Category is required';
    if (!rounds) return 'Rounds is required';
    if (!timer) return 'Timer is required';

    return '';
  };

  const handleStartGame = () => {
    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    const categoryWords = [...wordCategories[category]]; 

    const gameSettings = {
      category,
      rounds: parseInt(rounds),
      timer: parseInt(timer),
      words: categoryWords,
      selectedActor: parseInt(selectedActor),
    };

    socket.emit('start-game', { roomId, gameSettings });
    onClose();
  };

  return (
    <div className="fixed inset-0 p-4 sm:p-6 bg-black bg-opacity-60 flex items-center justify-center z-20">
      <div className="bg-yellow relative backdrop-blur-md rounded-xl w-full max-w-full sm:max-w-xl p-6 sm:p-8 shadow-xl transition-all duration-300 animate-fade-in text-black">

        <h2 className="text-3xl font-bold text-center mb-4">🎮 Game Settings</h2>
  
        {error && <p className="text-red-500 mb-4 text-sm">{error}</p>}
  
  
        <div className="text-left mb-4">
          <label className="block text-sm font-medium mb-2 roboto-f">Select Category:</label>
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="w-full py-2 px-4 rounded-full bg-white shadow-[0px_4px_6px_rgba(0,0,0,0.25)] border border-[#FFA600] focus:outline-none focus:ring-2 focus:ring-indigo-500"
          >
            {categories.map((cat) => (
              <option key={cat} value={cat} className="bg-white">{cat}</option>
            ))}
          </select>
        </div>
        
        <div className="text-left mb-4">
          <label className="block mb-2 text-sm font-medium roboto-f">Number of Rounds:</label>
          <input
            type="number"
            min="1"
            value={rounds}
            onChange={(e) => setRounds(e.target.value)}
            className="w-full py-2 px-4 rounded-full bg-white shadow-[0px_4px_6px_rgba(0,0,0,0.25)] border border-[#FFA600] focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
        </div>
  
        <div className="text-left  mb-4">
          <label className="block mb-2 text-sm font-medium roboto-f">Seconds per Round:</label>
          <input
            type="number"
            min="5"
            value={timer}
            onChange={(e) => setTimer(e.target.value)}
            className="w-full py-2 px-4 rounded-full bg-white shadow-[0px_4px_6px_rgba(0,0,0,0.25)] border border-[#FFA600] focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        <div className="text-left mb-6">
          <label className="block text-sm font-medium mb-2 roboto-f">
            {gameSyncData?.gameMode === 'team' ? 'Select Actor for Team 1' : 'Select Actor'}:
          </label>
          <select
            value={selectedActor}
            onChange={(e) => {
              setSelectedActor(e.target.value);
              //console.log('Selected player ID:', e.target.value);
            }}
            className="w-full py-2 px-4 rounded-full bg-white shadow-[0px_4px_6px_rgba(0,0,0,0.25)] border border-[#FFA600] focus:outline-none focus:ring-2 focus:ring-indigo-500"
          >
            {(gameSyncData?.gameMode === "team"
              ? gameSyncData.players?.filter((p) =>
                  gameSyncData.teams["Team 1"]?.includes(p.id) && p.online
                )
              : gameSyncData.players?.filter((p) => p.online)
            )?.map((player) => (
              <option key={player.id} value={player.id} className="bg-white">
                {player.name}
              </option>
            ))}
          </select>
        </div>

        <div className="flex justify-center">
          <button
            className="font-bold relative inline-block px-4 sm:px-6 py-2 sm:py-3 text-white font-bold text-base sm:text-lg 
              bg-[#FF1111] rounded-2xl shadow-[0_6px_0_0_#C30F0F]
              transition-all duration-150 ease-in-out
              hover:scale-[1.03]
              hover:brightness-110
              active:translate-y-[4px] active:shadow-none"
                onClick={handleStartGame}
            >
            Start Game
          </button>
        </div>
  
      </div>
    </div>
  );
};

export default RoomOptions;
